import {
   Box
  ,Fade
} from 'external/material'
import Assignment from './Assignment'

import useStudentContext from 'hooks/student'

export default function Assignments({id}) {
  const {assignments = {}} = useStudentContext()
  const counts = Object.entries(assignments[id] || {}) || []
  return (
  <Box className="assignments">
    <Fade in={counts.length > 0}>
      <Box className="wrapper">
        {counts.map(([type, count], i) => (<Assignment key={i} {...{id, count, type, iconProps: {height: 29, fill: '#92aabb'}}} />))}
      </Box>
    </Fade>
  </Box>
  )
}
